function Header(props) {
  const headerStyles = {
      borderBottom: '1px solid #000',
      padding:"40px 0 20px",
      fontSize: "20px",
      fontWeight:"600"
  }
    
  return (
    <>
      <div className="main-header" style={headerStyles}>
        <header>{props?.heading}</header>
      </div>
    </>
  );
}

export default Header;
